module.exports = __webpack_public_path__ + "img/9788961701037.06609058.jpg";